// extracted by mini-css-extract-plugin
export default {"buttonMainContainer":"ButtonMainAction_buttonMainContainer__uFZpn","buttonText":"ButtonMainAction_buttonText__D+43v","buttonImage":"ButtonMainAction_buttonImage__H1vMU"};